export const FETCH_CART_DETAILS_TAG = 'FETCH_CART_DETAILS';
export const FETCH_CART_ORDER_TOTALS_TAG = 'FETCH_CART_ORDER_TOTALS';
export const FETCH_CART_ORDER_DETAILS_TAG = 'FETCH_CART_ORDER_DETAILS_TAG';
export const TAX_AND_FREIGHT_TAG = 'TAX_AND_FREIGHT_TAG';

export const FAULTINJECT_PRICEANDAVAILABILITY =
  'faultInject_priceAndavailability';
export const FAULTINJECT_PRICEANDAVAILABILITY_VALUE = 'value_1';
export const FAULTINJECT_UPDATE_LINE_ITEMS = 'faultInject_updateLineItems';
export const FAULTINJECT_SAVE_SETTINGS = 'faultInject_saveSettings';
export const FAULTINJECT_CHECKOUT = 'faultInject_checkout';
export const FAULTINJECT_EMAIL_CART_TO_DEALER = 'faultInject_emailCartToDealer';
export const FAULTINJECT_GENERIC_ERROR = 'GENERIC_ERROR';
export const FAULTINJECT_EMPTY_CART = 'faultinject_emptyCart';
export const FAULTINJECT_ORDER_TOTALS = 'faultInject_orderTotals';
export const FAULTINJECT_ORDER_DETAILS = 'faultInject_orderDetails';
export const FAULTINJECT_FETCH_CART_DETAIL = 'faultInject_fetchCartDetails';
export const FAULTINJECT_FETCH_CART_DETAIL_POST =
  'faultInject_fetchPostCartDetails';
export const FAULTINJECT_FETCH_CART_DETAIL_GET =
  'faultInject_fetchGetCartDetails';
export const FAULTINJECT_VALIDATE_CART_ITEMS = 'faultInject_validateCartItems';
export const FAULTINJECT_REMOVE_SSRO_BUNDLES = 'faultInject_removeSsroBundles';
export const FAULTINJECT_SHARE_CART_LINK = 'faultInjection_shareCartLink';
export const FAULTINJECT_ADD_ITEMS = 'faultInject_addItems';
export const FAULTINJECT_ADD_ITEMS_FROM_SOS = 'faultInject_addItemsFromSOS';
export const FAULTINJECT_UPDATE_ORDER_ATTRIBUTES =
  'faultInject_updateorderAttributes';
export const FAULTINJECT_FULLFILLMENT = 'faultInject_fullfillment';

export const STATUS = {
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
  VALIDATION: 'validation',
  WARNING: 'warning',
  SOS: 'source-of-supply',
  HAS_REPLACEMENT: 'has-replacement',
  HAS_ALTERNATIVE: 'has-alternative'
};

export const PART_TYPE = {
  REMAN: 'Reman',
  CLASSIC: 'Classic',
  ALTERNATE: 'Alternate',
  DEALERREMAN: 'Dealer Reman',
  DEALERALTERNATE: 'Dealer Alternate'
};

export const CART_COOKIES = [
  'zeroPriceString',
  'indirectReplacedString',
  'indirectReplacedParts',
  'invalidParts'
];
